import { router, useLocalSearchParams, useNavigation } from 'expo-router';
import { useEffect, useLayoutEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import GoBackButton from '@/components/buttons/GoBackButton';
import PastorForm from '@/components/forms/PastorForm';
import FormWrapper from '@/components/forms/FormWrapper';
import Title from '@/components/Title';
import { PastorData } from '@/lib/validations/NpoOnboardingSchema';
import { i18n } from '@/utils/i18n';
import { safeJsonParse } from '@/utils/jsonParse';

const AddUpdatePastor = () => {
  const navigation = useNavigation<any>();
  const { pastorDataJson, pastorIndex } = useLocalSearchParams<{
    pastorDataJson: string;
    pastorIndex: string;
  }>();
  const [initialPastorData, setInitialPastorData] = useState<PastorData | undefined>(undefined);

  useLayoutEffect(() => {
    navigation.setOptions({
      headerShown: true,
      headerTransparent: true,
      headerTitle: () => <Title label={i18n.t('sign_in.nonProfit.pastors.add_title')} />,
      headerLeft: () => <GoBackButton navigateTo={'/login/nonProfit/onBoarding/pastors'} />,
      headerBackVisible: false
    });
  }, [navigation]);

  useEffect(() => {
    if (pastorDataJson) {
      const parsedPastor = safeJsonParse<PastorData>(pastorDataJson);
      if (parsedPastor) setInitialPastorData(parsedPastor);
    }
  }, [pastorDataJson]);

  return (
    <SafeAreaView style={styles.content}>
      <FormWrapper keyboardVerticalOffset={0} scrollEnable={false}>
        <View style={styles.container}>
          <PastorForm
            initialData={initialPastorData}
            showDoneButton
            onDone={(data) => {
              router.dismissTo({
                pathname: '/(app)/login/nonProfit/onBoarding/pastors',
                params: {
                  pastorDataJson: JSON.stringify(data),
                  pastorIndex: pastorIndex
                }
              });
            }}
          />
        </View>
      </FormWrapper>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  content: {
    flex: 1
  },

  container: {
    flex: 1,
    marginTop: 60
  }
});

export default AddUpdatePastor;
